import { Controller } from "@hotwired/stimulus"

// Handles clickable table rows and divs in admin interface
export default class extends Controller {
  connect() {
    // Use event delegation on the controller element
    this.element.addEventListener("click", this.handleClick.bind(this))
  }

  disconnect() {
    this.element.removeEventListener("click", this.handleClick.bind(this))
  }

  handleClick(event) {
    // Check if the click originated from an element that should not trigger navigation
    if (event.target.closest('[data-no-navigate]')) {
      return
    }
    
    // Find the closest element with data-url attribute
    const clickableElement = event.target.closest("[data-url]")
    
    if (clickableElement && this.element.contains(clickableElement)) {
      const url = clickableElement.dataset.url
      
      if (url) {
        // Check if it's a modifier key click (for opening in new tab)
        if (event.metaKey || event.ctrlKey) {
          window.open(url, "_blank")
        } else {
          // Use Turbo for navigation
          window.location.href = url
        }
      }
    }
  }
}